import NativeSlider from './components/native-slider'

/**
 * @see ./config.example.js
 */
export default {
  initializerOpts: {},
  modules: {
    nativeSlider: {
      module: NativeSlider
    }
  }
}
